var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4089_11579)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 140C47.8109 140 20 112.186 20 78.0072C20 43.8285 47.8109 16 82 16C116.189 16 144 43.8142 144 78.0072C144 112.2 116.189 140 82 140Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.233 78.0076C137.233 108.508 112.508 133.234 81.9927 133.234C51.4775 133.234 26.7666 108.508 26.7666 78.0076C26.7666 47.5069 51.4919 22.7672 82.007 22.7672C112.522 22.7672 137.247 47.4925 137.247 78.0076H137.233Z",
    fill: "url(#paint0_linear_4089_11579)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M137.233 78.0076C137.233 108.508 112.508 133.234 81.9927 133.234C51.4775 133.234 26.7666 108.508 26.7666 78.0076C26.7666 47.5069 51.4919 22.7672 82.007 22.7672C112.522 22.7672 137.247 47.4925 137.247 78.0076H137.233Z",
    fill: "url(#paint1_linear_4089_11579)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.451 99.0548C102.106 99.0979 101.144 99.1841 100.842 99.3853C100.827 99.3997 100.799 99.3997 100.784 99.4284C100.468 99.687 100.095 100.391 99.8936 100.764C98.9454 102.489 98.0116 104.026 96.1008 104.83C95.6267 105.017 95.1382 105.146 94.6498 105.218C93.2131 105.405 91.9201 105.06 90.5552 104.658C90.196 104.572 89.2766 104.27 88.9174 104.342C88.903 104.342 88.903 104.356 88.8743 104.356C88.472 104.486 87.8543 104.988 87.5238 105.247C86.3457 106.195 85.2251 107.028 83.8315 107.373C86.1015 115.189 86.4176 115.261 89.4202 122.976C92.5666 119.657 95.6985 116.352 98.8592 113.034C102.939 114.542 107.02 116.051 111.114 117.574C107.824 108.796 107.235 107.675 104.75 98.6957C104.017 98.8968 103.255 98.983 102.451 99.0836V99.0548Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4098 105.233C77.1368 105.017 76.3897 104.399 76.0305 104.327H75.9874C75.5708 104.284 74.8094 104.529 74.4071 104.644C72.5107 105.189 70.7579 105.606 68.8471 104.83C68.3874 104.629 67.9564 104.371 67.5541 104.069C66.3904 103.178 65.7295 102.029 65.0399 100.779C64.8819 100.463 64.4222 99.6152 64.1061 99.414C64.0917 99.414 64.0917 99.3996 64.063 99.3996C63.7038 99.1985 62.8993 99.1267 62.4826 99.0836C61.6781 98.9974 60.9167 98.8824 60.2127 98.6957C57.6985 107.675 57.7272 108.738 54.4229 117.516C58.503 116.008 62.5832 114.499 66.6634 112.976C69.8097 116.295 72.9704 119.599 76.1167 122.918C79.1194 115.189 78.8321 115.189 81.1164 107.359H80.9871C79.5648 106.957 78.5304 106.138 77.3954 105.247L77.4098 105.233Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.105 77.806C112.536 75.6222 115.237 74.1281 115.237 71.9012C115.237 69.6743 112.536 68.2089 112.105 66.0252C111.674 63.8414 113.6 61.4422 112.738 59.3733C111.904 57.3189 108.815 56.9741 107.58 55.1351C106.359 53.2818 107.221 50.3079 105.626 48.7419C104.06 47.1759 101.086 48.0379 99.2472 46.788C97.3938 45.5525 97.0634 42.4923 95.009 41.6303C92.9545 40.7683 90.5409 42.7078 88.3571 42.2625C86.1734 41.8458 84.6792 39.1305 82.4524 39.1305C80.2255 39.1305 78.7601 41.8458 76.5763 42.2625C74.3926 42.6935 71.9933 40.7683 69.9245 41.6303C67.87 42.4923 67.5252 45.5525 65.6863 46.788C63.833 48.0236 60.859 47.1759 59.293 48.7419C57.7271 50.3079 58.5891 53.2818 57.3392 55.1351C56.1036 56.9741 53.0435 57.3189 52.1815 59.3733C51.3195 61.4278 53.259 63.8414 52.8136 66.0252C52.397 68.2089 49.6816 69.6887 49.6816 71.9012C49.6816 74.1137 52.397 75.6222 52.8136 77.806C53.2446 79.9897 51.3195 82.389 52.1815 84.4578C53.0435 86.5123 56.1036 86.8427 57.3392 88.696C58.5747 90.535 57.7271 93.5089 59.293 95.0749C60.859 96.6552 63.833 95.8076 65.6863 97.0288C67.5252 98.2643 67.87 101.339 69.9245 102.186C71.9789 103.048 74.3926 101.109 76.5763 101.554C78.7601 101.985 80.2399 104.686 82.4524 104.686C84.6648 104.686 86.1734 101.985 88.3571 101.554C90.5409 101.123 92.9401 103.048 95.009 102.186C97.0634 101.353 97.3938 98.2643 99.2472 97.0288C101.086 95.8076 104.06 96.6696 105.626 95.0749C107.206 93.5089 106.359 90.535 107.58 88.696C108.815 86.8427 111.89 86.5123 112.738 84.4578C113.6 82.4034 111.66 79.9897 112.105 77.806ZM82.4667 96.1668C69.0768 96.1668 58.2012 85.3054 58.2012 71.9012C58.2012 58.497 69.0768 47.6356 82.4667 47.6356C95.8566 47.6356 106.732 58.5113 106.732 71.9012C106.732 85.2911 95.871 96.1668 82.4667 96.1668Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4813 49.9637C70.3701 49.9637 60.5288 59.805 60.5288 71.9162C60.5288 84.0275 70.3701 93.8831 82.4813 93.8831C94.5925 93.8831 104.448 84.0418 104.448 71.9162C104.448 59.7906 94.6069 49.9637 82.4813 49.9637ZM97.3222 66.7586L77.4098 86.671C77.4098 86.671 77.4098 86.671 77.3955 86.671L65.1406 74.4161C63.6608 72.9363 63.6751 70.5514 65.1837 69.086C66.6634 67.6493 69.0627 67.7642 70.5137 69.2296L77.3811 76.097C77.3811 76.097 77.3811 76.097 77.3955 76.097L92.0209 61.4716C93.4863 60.0062 95.8424 60.0062 97.3079 61.4716C98.7733 62.937 98.7733 65.2931 97.3079 66.7586H97.3222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4089_11579",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4089_11579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4089_11579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_11579",
    x1: 19.9998,
    y1: 22.7672,
    x2: 21.4365,
    y2: 133.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4089_11579",
    x1: 19.9998,
    y1: 22.7672,
    x2: 21.4365,
    y2: 133.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1St);
export default __webpack_public_path__ + "static/media/1st.d8c4fb414d297e18bad487f7eb8e0ceb.svg";
export { ForwardRef as ReactComponent };